import * as R from 'ramda';
import {createAction} from 'redux-actions';

import UserProfileApiClient from 'js/creator/user_profile_api_client/index';

// action types
const PATCH_PROFILE = 'PATCH_PROFILE';
const USER_PROFILE_UPDATED = 'USER_PROFILE_UPDATED';

// action creators
export const patchProfile = createAction(PATCH_PROFILE, UserProfileApiClient.patchProfile);
export const updateUserProfileStore = createAction(USER_PROFILE_UPDATED);

// reducers
export default {
    [PATCH_PROFILE]: R.identity,
    [USER_PROFILE_UPDATED]: (state, {payload: userProfile}) => {
        return {
            ...state,
            user: {
                ...state.user,
                profile: userProfile
            }
        };
    }
};



// WEBPACK FOOTER //
// ./creator/ducks/user_profile.js